import { createGlobalStyle } from "styled-components"

export const lightTheme = {
  background: "#FFFFFF",
  text: "#1A1A1A",
  primary: "#3B82F6",
  primaryLight: "#93C5FD",
  secondary: "#F3F4F6",
  secondaryText: "#4B5563",
  border: "#E5E7EB",
  card: "#FFFFFF",
  cardBorder: "#E5E7EB",
  success: "#10B981",
  error: "#EF4444",
  warning: "#F59E0B",
  muted: "#9CA3AF",
  accent: "#F3F4F6",
  input: "#F9FAFB",
}

export const darkTheme = {
  background: "#111827",
  text: "#F9FAFB",
  primary: "#3B82F6",
  primaryLight: "#1E40AF",
  secondary: "#1F2937",
  secondaryText: "#D1D5DB",
  border: "#374151",
  card: "#1F2937",
  cardBorder: "#374151",
  success: "#059669",
  error: "#DC2626",
  warning: "#D97706",
  muted: "#6B7280",
  accent: "#374151",
  input: "#374151",
}

export const GlobalStyles = createGlobalStyle`
  * {
    box-sizing: border-box;
    margin: 0;
    padding: 0;
  }
  
  body {
    font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
    background-color: ${(props) => props.theme.background};
    color: ${(props) => props.theme.text};
    transition: all 0.2s ease-in-out;
  }
  
  a {
    color: ${(props) => props.theme.primary};
    text-decoration: none;
  }
  
  button {
    font-family: inherit;
  }
`

